// -------------------------------------
// #SLICK
// -------------------------------------

jQuery(document).ready(function ($) {
    var prevArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="slick-prev"><use href="#icon-arrow"/></svg>';
    var nextArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="slick-next"><use href="#icon-arrow"/></svg>';

    // $("#slick-hero").on('init', function(event, slick){
    //     setTimeout(function () {
    //         $('#slick-hero').addClass('slick-animation-start');
    //     }, 500);
    // });

    $("#slick-hero").slick({
        fade: false,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        swipeToSlide: true,
        lazyLoad: "progressive",
        speed: 60000,
        autoplaySpeed: 0,
        cssEase: 'linear',
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
            {
            breakpoint: 640,
                settings: {
                    speed: 20000,
                }
            },
        ]
    });

    $("#slick-area").slick({
        infinite: false,
        appendArrows: $('#area-arrows'),
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        swipeToSlide: true,
        slidesToShow: 3,
        lazyLoad: "progressive",
        responsive: [
            {
            breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
            breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '20px',
                }
            },
        ]
    });

    $("#slick-team").slick({
        infinite: false,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        swipeToSlide: true,
        slidesToShow: 5,
        lazyLoad: "progressive",
        responsive: [
            {
            breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
            breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
            breakpoint: 840,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
            breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '40px',
                }
            },
        ]
    });
});
